import axios from 'axios'
import uuidv4 from 'uuid/v4'

export const state = {
  modules: {},
  groupUserRoles: [],
  users: [],
}

export const getters = {
  getModules(state) {
    return state.modules
  },

  getGroupUserRoles(state) {
    return state.groupUserRoles
  },

  getUsers(state) {
    return state.users
  },
}

export const mutations = {
  SET_MODULES(state, newValue) {
    state.modules = newValue
  },
  SET_GROUP_USER_ROLES(state, newValue) {
    state.groupUserRoles = newValue
  },
  SET_USERS(state, newValue) {
    state.users = newValue
  },
}

export const actions = {
  getAllModules({ commit, state }) {
    return axios
      .get(`/v1/outlets/modules`)
      .then(response => {
        const modules = response.data
        if (modules !== {}) {
          commit('SET_MODULES', modules)
          return modules
        } else {
          return 'No modules'
        }
      })
      .catch(err => {
        throw err
      })
  },
  saveUserRole(
    { commit, state },
    {
      id,
      rev,
      name,
      currentRole,
      groupId,
      status,
      createdBy,
      createdDateTime,
      modifiedBy,
      modifiedDateTime,
    }
  ) {
    let userRoleDocument
    if (id === null && rev === null) {
      userRoleDocument = {
        _id: 'role_' + uuidv4(),
        name: name,
        type: 'role',
        groupId: groupId,
        module: currentRole,
        status: status,
        createdBy: createdBy,
        createdDateTime: createdDateTime,
        modifiedBy: '',
        modifiedDateTime: modifiedDateTime,
      }
    } else {
      userRoleDocument = {
        _id: id,
        _rev: rev,
        name: name,
        type: 'role',
        groupId: groupId,
        module: currentRole,
        status: status,
        createdBy: createdBy,
        createdDateTime: createdDateTime,
        modifiedBy: modifiedBy,
        modifiedDateTime: modifiedDateTime,
      }
    }
    return axios.post(`v1/userRoles/`, userRoleDocument).then(response => {
      return response.data
    })
  },
  getUsers({ commit, state }, { groupId, outlets }) {
    let params = {
      group_id: groupId,
      outlets: outlets,
    }
    return axios.get(`v1/users/`, { params: params }).then(response => {
      commit('SET_USERS', response.data)
      return response.data
    })
  },
  saveUser({ commit, state }, { userObject }) {
    return axios.post(`v1/users/`, userObject).then(response => {
      return response.data
    })
  },
  getUserRoles({ commit, state }, { groupId }) {
    return axios.get(`v1/userRoles/${groupId}`).then(response => {
      commit('SET_GROUP_USER_ROLES', response.data.docs)
      return response.data.docs
    })
  },
  deleteUserDocument(
    { commit, state },
    { documentId: userDocumentId, rev: userDocumentRev }
  ) {
    return axios
      .delete(`/v1/users/${userDocumentId}/${userDocumentRev}`)
      .then(response => {
        return response.data
      })
  },
  deleteUserRoleDocument(
    { commit, state },
    { documentId: userRoleDocumentId, rev: userRoleDocumentRev }
  ) {
    return axios
      .delete(`/v1/userRoles/${userRoleDocumentId}/${userRoleDocumentRev}`)
      .then(response => {
        return response.data
      })
  },
}
